import axios from "axios";
import { v3Url } from "@/services/api/apiPrefix";

export default {
  namespaced: true,
  state: {
    response: null,
    error: null,
    loading: false,
  },
  mutations: {
    setAddress(state, response) {
      state.response = response; // Atualiza o estado com os dados do endereço
    },
    setError(state, error) {
      state.error = error; // Atualiza o estado de erro
    },
    setLoading(state, loading) {
      state.loading = loading; // Atualiza o estado de carregamento
    },
  },
  actions: {
    async fetchAddressByPostalCode({ commit, rootState }, postalCode) {
      commit("setLoading", true);
      try {
        // Obtém o token do Vuex (certifique-se de que o token está no módulo 'auth')
        const token = rootState.auth.token; // Acessando diretamente o estado do módulo 'auth'

        if (!token) {
          throw new Error("Token de autenticação não encontrado");
        }

        // Realiza a requisição para buscar o endereço
        const response = await axios.get(
          v3Url(`/address/postalcode/${postalCode}`),
          {
            headers: {
              "Content-Type": "application/json",
              AuthorizationIntegrator: `${token}`, // Cabeçalho correto para autenticação (verifique se o "Bearer" é necessário)
            },
          },
        );

        // Verifica se a resposta é válida e atribui ao estado
        if (response.data && response.data.success) {
          commit("setAddress", response.data.response); // Salva os dados do endereço no Vuex
        } else {
          commit("setError", "Não foi possível encontrar o endereço");
        }
      } catch (error) {
        // Tratamento de erro mais robusto
        if (error.response) {
          // Se a resposta do servidor estiver disponível
          commit(
            "setError",
            error.response.data.message || "Erro ao buscar o endereço",
          );
        } else if (error.request) {
          // Se a requisição foi feita, mas não houve resposta
          commit("setError", "Erro de conexão com o servidor");
        } else {
          // Erro desconhecido
          commit("setError", error.message || "Erro desconhecido");
        }
      } finally {
        commit("setLoading", false); // Finaliza a operação de carregamento
      }
    },
  },
  getters: {
    getAddress(state) {
      return state.response;
    },
    getError(state) {
      return state.error;
    },
    getLoading(state) {
      return state.loading;
    },
  },
};
